import React from "react";

import { PaymentHistory as PaymentHistoryType } from "api/Payment/PaymentService";

import styles from "./PaymentHistory.module.scss";

interface PaymentHistoryProps {
  history: PaymentHistoryType[];
  error?: string;
  isStripeConnected: boolean;
  onSetupStripe: () => void;
}

const PaymentHistory: React.FC<PaymentHistoryProps> = ({ history }) => {
  return (
    <div className={styles.container}>
      <h3>Payment History</h3>
      {history.length === 0 ? (
        <div className={styles.emptyState}>No payments made yet...</div>
      ) : (
        <div className={styles.tableContainer}>
          <table className={styles.historyTable}>
            <thead>
              <tr>
                <th>Amount</th>
                <th>Amount Paid</th>
                <th>Currency</th>
                <th>Payment Date</th>
              </tr>
            </thead>
            <tbody>
              {history.map((payment) => (
                <tr key={payment.id}>
                  <td>{payment.amount}</td>
                  <td>{payment.credits_purchased}</td>
                  <td>{payment.currency}</td>
                  <td>
                    {new Date(payment.created_timestamp).toLocaleString(
                      "en-US",
                      {
                        year: "numeric",
                        month: "numeric",
                        day: "numeric",
                        hour: "numeric",
                        minute: "2-digit",
                        hour12: true,
                      },
                    )}
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      )}
    </div>
  );
};

export default PaymentHistory;
